import Slider from './slider';

document.addEventListener('DOMContentLoaded', () => {
	// Add imported items here.
	Slider();
});
